module.exports = __webpack_public_path__ + "static/media/flower4.f06e7f20.png";